module.exports = __webpack_public_path__ + "img/3.0ccf40ca.jpg";